import React from 'react';
import Card from './Card';
import {
  DeliveryRateIcon,
  OpenRateIcon,
  ClickThroughRateIcon,
} from '../../SVGs/Icons';

const AllChannels = ({
  emailEvents,
  generateRatio,
  textEvents,
  isDataAvailable,
  isSmartResendAvailable,
  smartResendEmailEvents,
  messageStatus,
  isMessageCancelled,
  hasMessageSmartResend,
}) => {
  const calcSmartResendClickThroughRate = () => {
    const oldRatio = generateRatio(
      emailEvents.uniqueclick,
      emailEvents.uniqueopen
    );

    const newRatio = generateRatio(
      emailEvents.uniqueclick + smartResendEmailEvents.uniqueclick,
      emailEvents.uniqueopen + smartResendEmailEvents.uniqueopen
    );

    return parseInt(newRatio) - parseInt(oldRatio) + '%';
  };

  const deliveryRateTileValue = () => {
    return generateRatio(
      emailEvents.delivered + textEvents.delivered,
      emailEvents.sent + textEvents.sent
    );
  };

  const deliveryRateTileResendValue = () => {
    if (!smartResendEmailEvents?.delivered) return null;

    return generateRatio(
      smartResendEmailEvents.delivered,
      smartResendEmailEvents.sent
    );
  };

  return (
    <>
      <Card
        name="Delivery Rate"
        value={deliveryRateTileValue()}
        smartResendValue={deliveryRateTileResendValue()}
        title="The average of your email and text successful deliveries."
        isDataAvailable={isDataAvailable}
        isSmartResendAvailable={isSmartResendAvailable}
        Icon={DeliveryRateIcon}
        messageStatus={messageStatus}
        stats={
          emailEvents.delivered +
          textEvents.delivered +
          (smartResendEmailEvents?.delivered || 0)
        }
        smartResendStats={smartResendEmailEvents?.delivered ?? 0}
        isMessageCancelled={isMessageCancelled}
        hasMessageSmartResend={hasMessageSmartResend}
      />
      <Card
        name="Open Rate"
        value={generateRatio(
          emailEvents.uniqueopen + (smartResendEmailEvents?.uniqueopen || 0),
          emailEvents.delivered
        )}
        smartResendValue={
          smartResendEmailEvents?.uniqueopen ||
          smartResendEmailEvents?.delivered
            ? generateRatio(
                smartResendEmailEvents.uniqueopen,
                emailEvents.delivered
              )
            : null
        }
        title="The average of your email unique open rates."
        isDataAvailable={isDataAvailable}
        isSmartResendAvailable={isSmartResendAvailable}
        showComparativeAnalytics
        Icon={OpenRateIcon}
        messageStatus={messageStatus}
        stats={
          emailEvents.uniqueopen + (smartResendEmailEvents?.uniqueopen || 0)
        }
        smartResendStats={smartResendEmailEvents?.uniqueopen ?? 0}
        isMessageCancelled={isMessageCancelled}
        hasMessageSmartResend={hasMessageSmartResend}
      />
      <Card
        name="Click-Through Rate"
        value={generateRatio(
          emailEvents.uniqueclick + (smartResendEmailEvents?.uniqueclick || 0),
          emailEvents.uniqueopen + (smartResendEmailEvents?.uniqueopen || 0)
        )}
        smartResendValue={
          smartResendEmailEvents?.uniqueclick ||
          smartResendEmailEvents?.uniqueopen
            ? calcSmartResendClickThroughRate()
            : null
        }
        title="The average of your email and text click-to-open rates."
        isDataAvailable={isDataAvailable}
        isSmartResendAvailable={isSmartResendAvailable}
        showComparativeAnalytics
        Icon={ClickThroughRateIcon}
        messageStatus={messageStatus}
        stats={
          emailEvents.uniqueclick + (smartResendEmailEvents?.uniqueclick || 0)
        }
        smartResendStats={smartResendEmailEvents?.uniqueclick ?? 0}
        isMessageCancelled={isMessageCancelled}
        hasMessageSmartResend={hasMessageSmartResend}
      />
    </>
  );
};

export default AllChannels;
